"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QnACategoryDropDown = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const categoryDropdownList = [
    { id: 'select', title: 'supportRoom.category' },
    { id: 'lesson', title: 'supportRoom.lesson' },
    { id: 'subject', title: 'supportRoom.subject' },
    { id: 'textbook', title: 'supportRoom.textbook' },
    { id: 'attendance', title: 'supportRoom.attendance' },
    { id: 'preview', title: 'supportRoom.preview' },
    { id: 'system', title: 'supportRoom.system' },
    { id: 'gmk', title: 'supportRoom.gmk' },
    { id: 'etc', title: 'supportRoom.etc' },
];
exports.QnACategoryDropDown = react_1.default.memo(({ category, setCategory }) => {
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [value, setValue] = react_1.default.useState({
        id: 'select',
        title: 'supportRoom.category',
    });
    react_1.default.useEffect(() => {
        if (category !== value.id)
            setValue(categoryDropdownList.find(item => item.id === category) ||
                categoryDropdownList[0]);
    }, [category]);
    const handlerUpdateDrop = (item) => {
        setValue(item);
        setCategory(item.id);
    };
    return (react_1.default.createElement(common_1.DropDown, { className: "dropdown-tablet-small", list: categoryDropdownList, value: value, styles: {
            ...(!isMobile && { dropWrap: { width: 150 } }),
            itemWrap: {
                top: isTablet ? '50px' : '45px',
            },
        }, setDropValue: handlerUpdateDrop }));
});
